import { css } from '@emotion/react';
import { unit, themed } from '@spotnana/blocks/src/utils/styling';
import { paddings } from '@spotnana/blocks/src/utils/styling/utilityTokens';

export const copyable_text = themed(
  ({ palette }) =>
    css`
      button&.BlocksButton-ghost {
        > .BlocksButton-Icon {
          color: ${palette.text.secondary};
        }
        color: ${palette.text.secondary};
        ${paddings.x.tight}

        /*
         * These styles are necessary for the button props to work correctly with the adjusted padding in the line above.
         * The specificity is 0,6,1 which is 1 point higher than in blocks. 
         */
        &.MuiButton-root.MuiButton-sizeSmall.BlocksButton-root.edge-placement-left {
          transform: translateX(-${unit(0.5)});
        }
        &.MuiButton-root.MuiButton-sizeSmall.BlocksButton-root.edge-placement-right {
          transform: translateX(-${unit(0.5)});
        }
      }
    `,
);
